<template>
  <div v-if="preloader" class="d-flex flex-root justify-content-center align-items-center">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
  <div v-else class="container">
    <div class="d-flex justify-content-between">
      <h3 class="card-title align-items-start flex-column m-4">
        <span class="card-label fw-bolder text-dark fs-3">
          {{ username}}
        </span>
      </h3>
      <SignOut/>
    </div>
    <div class="row g-5">
      <div class="col-lg-4">
        <MyCompanyShare :my="my"/>
      </div>
      <div class="col-lg-8">
        <CompanyRevenue :statistic="statistic"/>
      </div>
    </div>
    <div class="row g-5">
      <div class="col-lg-4">
        <MyCompanyShareIPO :my="my" :statistic="statistic"/>
      </div>
      <div class="col-lg-8">
        <TableCompanyShare :years="years"/>
      </div>
    </div>
    <div class="row g-5">
      <div class="col-lg-4">
        <TimelineCompanyShare/>
      </div>
      <div class="col-lg-8">
        <TableCompanyShareIncrease :my="my" :years="years" :statistic="statistic"/>
      </div>
    </div>
  </div>
</template>

<script>
import store from "../stores/store";

import CompanyRevenue from "../widgets/CompanyStatistic"
import MyCompanyShare from "../widgets/MyCompanyShare"
import TimelineCompanyShare from "../widgets/TimelineCompanyShare"
import TableCompanyShare from "../widgets/TableCompanyShare"
import TableCompanyShareIncrease from "../widgets/TableCompanyShareIncrease"
import MyCompanyShareIPO from "../widgets/MyCompanyShareIPO"
import SignOut from "../widgets/components/SignOut";

export default {
  name: "MyShareDashboard",

  components: {
    SignOut,
    MyCompanyShareIPO,
    CompanyRevenue,
    MyCompanyShare,
    TimelineCompanyShare,
    TableCompanyShare,
    TableCompanyShareIncrease,
  },

  data() {
    return {
      preloader: true,
    }
  },

  computed: {
    my() {
      return store.state.share.my
    },
    years() {
      return store.state.share.years
    },
    statistic() {
      return store.state.company.statistic
    },
    username() {
      return store.state.username
    }
  },

  created() {
    this.fetchData()
  },

  methods: {
    async fetchData() {
      try {
        await Promise.all([
          await store.dispatch('fetchCompanyStatistic'),
          await store.dispatch('fetchShareSummary')
        ])
      } catch (e) {
        throw e;
      } finally {
        this.preloader = false;
      }
    },
  }
}
</script>

<style scoped>

</style>
